module.exports = __webpack_public_path__ + "static/media/zola.51330e8d.jfif";